export const LOGIN = 'APP_LOGIN';
export const LOGOUT = 'APP_LOGOUT';
export const INIT = 'APP_INIT';
export const WHOAMI = 'APP_WHOAMI';
export const KEEPTOKEN = 'APP_KEEPTOKEN';
export const LOGWITHTOKEN = 'APP_LOGWITHTOKEN';
export const PERMISSIONLIST = 'APP_PERMISSIONLIST';
export const SET_BANK_ACCOUNT = 'APP_SET_BANK_ACCOUNT';
